"use strict";

exports.__esModule = true;
exports.default = void 0;
var _loopCreate = _interopRequireDefault(require("./loopCreate"));
var _loopFix = _interopRequireDefault(require("./loopFix"));
var _loopDestroy = _interopRequireDefault(require("./loopDestroy"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = {
  loopCreate: _loopCreate.default,
  loopFix: _loopFix.default,
  loopDestroy: _loopDestroy.default
};
exports.default = _default;